// Contenu éditorial du blog du bailleur. Ajoutez un objet pour publier un nouvel article.
export const BLOG_POSTS = [
  {
    slug: "encadrement-des-loyers-suis-je-concerne",
    title: "Encadrement des loyers : suis-je concerné ?",
    description:
      "Zones concernées, loyer de référence, majoré et minoré, complément de loyer : comprenez l'encadrement des loyers et vérifiez si votre bien y est soumis.",
    category: "Réglementation",
    date: "2026-06-18",
    readingTime: "5 min",
    cover: "https://images.unsplash.com/photo-1688646953306-5ec93eab8c06?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    coverAlt: "Immeuble d'habitation en ville",
    excerpt:
      "Certaines villes plafonnent les loyers. Voici comment savoir si votre logement est concerné et comment fixer un loyer conforme.",
    intro:
      "Dans plusieurs grandes agglomérations, le loyer que vous pouvez demander est plafonné : c'est l'encadrement des loyers. Ne pas le respecter expose à des sanctions et à un remboursement du trop-perçu. Voici comment savoir si vous êtes concerné.",
    sections: [
      {
        title: "Qu'est-ce que l'encadrement des loyers ?",
        paragraphs: [
          "L'encadrement des loyers fixe, pour un logement donné, un loyer de référence majoré à ne pas dépasser. Il s'applique dans certaines zones tendues volontaires, sur décision locale, et concerne aussi bien les nouvelles locations que les relocations.",
        ],
      },
      {
        title: "Suis-je concerné ?",
        paragraphs: ["Vous êtes potentiellement concerné si votre logement remplit ces conditions :"],
        bullets: [
          "Il se situe dans une commune ayant mis en place l'encadrement (Paris, Lille, Lyon, Montpellier, Bordeaux et plusieurs autres, la liste évoluant régulièrement)",
          "C'est une location à usage de résidence principale (vide ou meublée)",
          "Il ne relève pas d'une exception (certains logements sociaux ou conventionnés)",
        ],
      },
      {
        title: "Loyer de référence, majoré, minoré",
        paragraphs: [
          "Pour chaque secteur, type de logement et époque de construction, un arrêté fixe un loyer de référence exprimé en euros par m². Le loyer demandé ne peut pas dépasser le loyer de référence majoré (généralement +20 %).",
          "En cas de baisse de loyer, le loyer de référence minoré sert de plancher pour certaines actions du locataire.",
        ],
      },
      {
        title: "Le complément de loyer",
        paragraphs: [
          "Un complément de loyer peut être appliqué au-delà du plafond lorsque le logement présente des caractéristiques exceptionnelles (vue, terrasse, prestations rares). Il doit être justifié et mentionné dans le bail, faute de quoi le locataire peut le contester.",
        ],
      },
      {
        title: "Fixer un loyer conforme",
        paragraphs: [
          "Avant de publier votre annonce, vérifiez le loyer de référence applicable à votre bien sur le site de votre commune ou de la préfecture. Mentionnez systématiquement le loyer de référence et le loyer de référence majoré dans le bail : c'est une obligation dans les zones concernées.",
        ],
      },
    ],
  },
  {
    slug: "regularisation-des-charges-locatives",
    cta: {
      title: "Votre décompte de régularisation calculé automatiquement",
      text: "Provisions encaissées, charges réelles par poste et solde : le tableau se calcule seul, avec un courrier d'accompagnement personnalisable.",
      button: "Faire ma régularisation",
    },
    title: "Régularisation des charges locatives : mode d'emploi",
    description:
      "Provisions, charges récupérables, décompte annuel et justificatifs : comment régulariser les charges locatives correctement, sans litige avec votre locataire.",
    category: "Gestion",
    date: "2026-06-11",
    readingTime: "5 min",
    cover: "https://images.pexels.com/photos/6920439/pexels-photo-6920439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1200",
    coverAlt: "Salon moderne d'un logement en location",
    excerpt:
      "Chaque année, le bailleur ajuste les provisions pour charges aux dépenses réelles. Voici comment faire une régularisation carrée.",
    intro:
      "Quand le locataire verse des provisions pour charges chaque mois, le bailleur doit régulariser une fois par an : comparer ce qui a été provisionné aux dépenses réellement engagées, puis rembourser le trop-perçu ou réclamer le complément. Voici la méthode.",
    sections: [
      {
        title: "Provisions ou forfait ?",
        paragraphs: [
          "En location vide, les charges sont généralement versées sous forme de provisions mensuelles, régularisées une fois par an. En location meublée, le bail peut prévoir un forfait de charges, non régularisable : dans ce cas, aucune régularisation n'est nécessaire.",
        ],
      },
      {
        title: "Quelles charges sont récupérables ?",
        paragraphs: ["Seules les charges dites récupérables peuvent être refacturées au locataire, notamment :"],
        bullets: [
          "L'eau et l'énergie des parties communes",
          "L'entretien des espaces communs et des espaces verts",
          "La taxe d'enlèvement des ordures ménagères",
          "Certains frais de fonctionnement de l'ascenseur et du chauffage collectif",
        ],
      },
      {
        title: "Comment calculer la régularisation",
        paragraphs: [
          "Additionnez les provisions versées par le locataire sur l'année, puis comparez-les au montant réel des charges récupérables (issu, en copropriété, du décompte du syndic).",
          "Si les provisions dépassent les charges réelles, vous remboursez la différence au locataire. Si elles sont insuffisantes, vous lui réclamez le complément.",
        ],
      },
      {
        title: "Information et justificatifs",
        paragraphs: [
          "Vous devez transmettre au locataire le décompte par nature de charges au moins un mois avant la régularisation, et tenir les justificatifs à sa disposition pendant six mois. Une régularisation transparente évite la plupart des litiges.",
        ],
      },
      {
        title: "Automatiser avec 360immoinvest",
        paragraphs: [
          "L'application suit vos provisions encaissées et vos dépenses de charges tout au long de l'année, puis prépare le décompte annuel à envoyer au locataire. Vous ne repartez pas de zéro chaque année.",
        ],
      },
    ],
  },
  {
    slug: "bail-meuble-ou-vide",
    title: "Bail meublé ou vide : quelles différences pour le bailleur ?",
    description:
      "Durée du bail, dépôt de garantie, fiscalité, préavis : comparez la location meublée et la location vide pour choisir la formule la plus adaptée à votre bien.",
    category: "Location",
    date: "2026-05-06",
    readingTime: "5 min",
    cover: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    coverAlt: "Signature d'un bail de location",
    excerpt:
      "Location meublée ou vide ? Deux régimes aux règles bien distinctes. Voici l'essentiel pour choisir en connaissance de cause.",
    intro:
      "Avant de mettre votre logement en location, une question revient toujours : faut-il le louer meublé ou vide ? Les deux options obéissent à des règles différentes en matière de durée, de dépôt de garantie, de préavis et surtout de fiscalité. Tour d'horizon pour décider sereinement.",
    sections: [
      {
        title: "Durée du bail et préavis",
        paragraphs: [
          "En location vide, le bail est conclu pour 3 ans (renouvelable) lorsque le bailleur est un particulier. Le locataire peut partir à tout moment avec un préavis d'un mois en zone tendue, trois mois ailleurs.",
          "En location meublée, le bail est d'un an (ou neuf mois pour un bail étudiant), et le préavis du locataire est réduit à un mois. Le meublé offre donc plus de souplesse, au prix d'une rotation plus fréquente.",
        ],
      },
      {
        title: "Dépôt de garantie",
        paragraphs: [
          "Le dépôt de garantie est plafonné à un mois de loyer hors charges en location vide, et à deux mois en location meublée. Cette différence s'explique par le risque supplémentaire lié au mobilier.",
        ],
      },
      {
        title: "Fiscalité : le vrai point de bascule",
        paragraphs: [
          "Les loyers d'une location vide sont imposés dans la catégorie des revenus fonciers (micro-foncier avec abattement de 30 % ou régime réel).",
          "Les loyers d'une location meublée relèvent des bénéfices industriels et commerciaux (BIC), avec le statut LMNP : abattement de 50 % en micro-BIC, ou déduction des charges et amortissement du bien au réel. Ce dernier point rend souvent le meublé fiscalement attractif.",
        ],
      },
      {
        title: "Que choisir ?",
        paragraphs: ["Il n'y a pas de bonne réponse universelle : tout dépend de votre bien et de vos objectifs."],
        bullets: [
          "Meublé : rendement et fiscalité optimisés, mais gestion plus active et rotation plus rapide.",
          "Vide : stabilité, moins de gestion, idéal pour un bien familial en zone recherchée.",
        ],
      },
    ],
  },
  {
    slug: "depot-de-garantie-montant-restitution-delais",
    title: "Dépôt de garantie : montant, restitution et délais",
    description:
      "Quel montant pour le dépôt de garantie ? Dans quel délai le restituer ? Que peut retenir le bailleur ? Le guide clair pour éviter les litiges.",
    category: "Gestion",
    date: "2026-05-14",
    readingTime: "4 min",
    cover: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    coverAlt: "Clés de logement posées sur une table",
    excerpt:
      "Montant, délai de restitution, retenues justifiées : maîtrisez les règles du dépôt de garantie pour une fin de bail sans accroc.",
    intro:
      "Le dépôt de garantie protège le bailleur contre d'éventuels manquements du locataire. Mais ses règles sont strictes, et les litiges en fin de bail sont fréquents. Voici ce qu'il faut savoir pour rester dans les clous.",
    sections: [
      {
        title: "Quel montant ?",
        paragraphs: [
          "Le dépôt est plafonné à un mois de loyer hors charges pour une location vide, et à deux mois pour une location meublée. Son montant est fixé dans le bail et versé à la signature.",
        ],
      },
      {
        title: "Dans quel délai le restituer ?",
        paragraphs: [
          "Le bailleur dispose d'un mois pour restituer le dépôt lorsque l'état des lieux de sortie est conforme à celui d'entrée. Ce délai passe à deux mois en cas de différences justifiant des retenues.",
          "Un retard de restitution expose le bailleur à des pénalités : le montant dû est majoré de 10 % du loyer mensuel par mois de retard entamé.",
        ],
      },
      {
        title: "Que peut retenir le bailleur ?",
        paragraphs: ["Les retenues doivent être justifiées par des documents :"],
        bullets: [
          "Loyers ou charges impayés",
          "Réparations locatives non effectuées (hors usure normale)",
          "Régularisation de charges en attente",
        ],
      },
      {
        title: "Éviter les litiges",
        paragraphs: [
          "La clé, c'est l'état des lieux : des constats d'entrée et de sortie précis, photos à l'appui, permettent de justifier chaque retenue. Conservez devis et factures pour toute réparation facturée au locataire.",
        ],
      },
    ],
  },
  {
    slug: "etat-des-lieux-guide-complet",
    title: "État des lieux d'entrée et de sortie : le guide complet",
    description:
      "Pourquoi l'état des lieux est essentiel, ce qu'il doit contenir, et comment le réaliser même à distance grâce à un référent local.",
    category: "Gestion",
    date: "2026-05-22",
    readingTime: "6 min",
    cover: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    coverAlt: "Salon d'un logement moderne",
    excerpt:
      "L'état des lieux est votre meilleure protection. Voici comment le réussir, à l'entrée comme à la sortie — même sans être sur place.",
    intro:
      "L'état des lieux est le document qui compare l'état du logement à l'entrée et à la sortie du locataire. C'est la pièce maîtresse pour justifier — ou contester — une retenue sur le dépôt de garantie. Autant le soigner.",
    sections: [
      {
        title: "Pourquoi il est indispensable",
        paragraphs: [
          "Sans état des lieux, le logement est réputé avoir été remis en bon état : le bailleur ne peut alors rien retenir en fin de bail. Un constat précis à l'entrée est donc votre première protection.",
        ],
      },
      {
        title: "Ce qu'il doit contenir",
        bullets: [
          "L'adresse du logement et la date du constat",
          "L'état de chaque pièce et des équipements, pièce par pièce",
          "Les relevés des compteurs (eau, électricité, gaz)",
          "Le nombre de clés remises",
          "Des photos datées, idéalement annexées au document",
        ],
      },
      {
        title: "Entrée et sortie : la comparaison",
        paragraphs: [
          "L'état des lieux de sortie doit reprendre la même structure que celui d'entrée pour permettre une comparaison poste par poste. Seules les dégradations dépassant l'usure normale peuvent être imputées au locataire.",
        ],
      },
      {
        title: "Le réaliser même à distance",
        paragraphs: [
          "Vous n'habitez pas près de votre bien ? Vous pouvez déléguer l'état des lieux à un référent local qui se rend sur place, réalise le constat et le partage dans l'application. Le document signé numériquement a la même valeur.",
        ],
      },
    ],
  },
  {
    slug: "checklist-bailleur-debutant",
    title: "Louer son logement : la checklist du bailleur débutant",
    description:
      "Diagnostics, bail, assurance, dépôt de garantie, quittances : la liste des étapes à ne pas oublier pour louer sereinement votre premier bien.",
    category: "Débuter",
    date: "2026-05-30",
    readingTime: "5 min",
    cover: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    coverAlt: "Séjour lumineux d'un appartement",
    excerpt:
      "Vous louez pour la première fois ? Suivez cette checklist pour partir du bon pied et éviter les oublis qui coûtent cher.",
    intro:
      "Mettre son premier logement en location peut sembler intimidant. En réalité, il suffit de suivre quelques étapes clés, dans le bon ordre. Voici la checklist du bailleur débutant.",
    sections: [
      {
        title: "Avant la mise en location",
        bullets: [
          "Rassembler les diagnostics obligatoires (DPE, électricité, gaz, plomb selon le bien)",
          "Vérifier que le logement est décent et aux normes",
          "Fixer un loyer cohérent avec le marché et l'encadrement éventuel de votre zone",
        ],
      },
      {
        title: "Au moment de la signature",
        bullets: [
          "Rédiger un bail conforme et l'annexer aux diagnostics",
          "Réaliser un état des lieux d'entrée détaillé",
          "Encaisser le dépôt de garantie (1 mois en vide, 2 en meublé)",
          "Vérifier l'attestation d'assurance habitation du locataire",
        ],
      },
      {
        title: "Pendant la location",
        bullets: [
          "Émettre une quittance à chaque paiement",
          "Réviser le loyer une fois par an selon l'IRL, si le bail le prévoit",
          "Régulariser les charges chaque année",
          "Conserver tous les justificatifs pour votre déclaration de revenus fonciers",
        ],
      },
      {
        title: "Gagner du temps",
        paragraphs: [
          "Un logiciel de gestion locative automatise le plus fastidieux : quittances, rappels de loyer, révision IRL et suivi des charges. De quoi gérer votre premier bien en quelques minutes par mois.",
        ],
      },
    ],
  },
  {
    slug: "gerer-un-impaye-de-loyer",
    cta: {
      title: "Vos 3 courriers de relance, prêts à envoyer",
      text: "Rappel amiable, relance ferme et mise en demeure pré-remplis avec le montant dû et les périodes impayées, à votre logo, en un clic depuis la location.",
      button: "Générer mes relances",
    },
    title: "Gérer un impayé de loyer : les étapes à suivre",
    description:
      "Relance amiable, mise en demeure, commandement de payer, assurance loyers impayés : la marche à suivre pour réagir vite et bien face à un impayé.",
    category: "Gestion",
    date: "2026-06-04",
    readingTime: "5 min",
    cover: "https://images.pexels.com/photos/27505120/pexels-photo-27505120.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1200",
    coverAlt: "Clés, calculatrice et documents financiers",
    excerpt:
      "Un loyer impayé n'est jamais agréable, mais une réaction rapide et méthodique fait toute la différence. Voici les étapes.",
    intro:
      "Face à un impayé de loyer, la pire attitude est d'attendre. Plus vous réagissez tôt, plus vous augmentez vos chances de récupérer les sommes dues à l'amiable. Voici la marche à suivre, étape par étape.",
    sections: [
      {
        title: "1. La relance amiable",
        paragraphs: [
          "Dès le premier retard, contactez le locataire : un simple oubli ou une difficulté passagère se règlent souvent par un rappel courtois. Proposez, si besoin, un échéancier écrit.",
        ],
      },
      {
        title: "2. La mise en demeure",
        paragraphs: [
          "Si le dialogue ne suffit pas, adressez une mise en demeure par lettre recommandée avec accusé de réception. Elle rappelle la dette, fixe un délai de règlement et marque le point de départ officiel de la procédure.",
        ],
      },
      {
        title: "3. Actionner les garanties",
        paragraphs: [
          "Selon votre situation, vous pouvez solliciter le garant (caution), déclarer le sinistre à votre assurance loyers impayés (GLI), ou saisir la garantie Visale le cas échéant. Vérifiez les délais de déclaration, souvent stricts.",
        ],
      },
      {
        title: "4. La procédure",
        paragraphs: [
          "En dernier recours, un commissaire de justice délivre un commandement de payer visant la clause résolutoire du bail. À défaut de régularisation, la procédure devant le juge peut mener à la résiliation du bail et à l'expulsion. Un accompagnement juridique est alors recommandé.",
        ],
      },
      {
        title: "Prévenir plutôt que guérir",
        paragraphs: [
          "Un suivi rigoureux des loyers et des relances automatiques permettent de détecter un impayé dès le premier jour. C'est souvent ce qui évite qu'une situation ne s'aggrave.",
        ],
      },
    ],
  },
];

export const getPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);

export const fmtBlogDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
};
